import $ = require("jquery");
import ko = require("knockout");
import _ = require("underscore");
import komap = require("knockout.mapping");
import Service = require("../Atlas/Service");
import Logger = require("../Atlas/Logger");
import FormResponseConditionEditorConfiguration = require("../Atlas/FormResponseConditionEditorConfiguration");
import {IResolvedUser, IAvailableActiveDirectoryRealms} from "./userGroupPicker";
import { ITextMergeFieldViewModel, ITextMergeFieldCategory, MergeFieldValueType } from "./mergeFieldChooser";
import Controls = require("../../ts/Atlas/Controls");

export = FormResponseConditionEditor;

module FormResponseConditionEditor {
    export class FormResponseConditionDto implements IFormResponseConditionDto {
        And: boolean = null;
        Or: boolean = null;
        Not: boolean = null;
        QuestionId: string = null;
        PeriodAttributeId: string = null;
        ValueMatch: string = null;
        RegexValue: string = null;
        ParentCompositeResponseConditionId: string = null;
        PhaseId: string = null;
        MinimumDate: string = null;
        MaximumDate: string = null;
        SubmitDate: boolean = null;
        LastModifiedDate: boolean = null;
        CurrentDate: boolean = null;
        MinutesBeforeAssociatedDate: number = null;
        MinimumNumberValue: number = null;
        MaximumNumberValue: number = null;
        FormSubmitted: boolean = null;
        FormWaitlisted: boolean = null;
        FormRegistered: boolean = null;
        ReservationAttemptSuccessful: boolean = null;
        FormCancelled: boolean = null;
        PaymentStatus: boolean = null;
        PaymentMethod: boolean = null;
        PaymentPromised: boolean = null;
        ReferenceFormId: string = null;
        MembershipProviderId: string = null;
        ResponseSubmitterIsMember: boolean = null;
        ResponseAssociatedUserIsMember: boolean = null;
        LastModifiedByIsMember: boolean = null;
        SignatureSigned: boolean = null;
        SignatureSignedBy: boolean = null;
        SignatureDate: boolean = null;
        PeriodId: string = null;
        ChildResponseConditions: IFormResponseConditionDto[] = [];
        TextMergeField: string = null;
        ResponseConditionValueType: FormBuilder.FormResponseConditionValueType = null;
        ResponseConditionValueTypeText: FormBuilder.FormResponseConditionValueType = null;
        HasValue: boolean = null;
        SavedForLater: boolean = null;
        MinimumReferenceFormMatchCount: number = null;
        MaximumReferenceFormMatchCount: number = null;
        MinimumReferenceFormMatchPercent: number = null;
        MaximumReferenceFormMatchPercent: number = null;
        ChildAggregate: boolean = null;
        ChildAggregateReferenceFormId: string = null;
    }

    export var FormResponseConditionValueType = {
        ValueMatch: "ValueMatch",
        RegexValue: "RegexValue",
        DateRange: "DateRange",
        NumberRange: "NumberRange",
        SubmitDateMinMax: "SubmitDateMinMax",
        SubmitDateProximity: "SubmitDateProximity",
        CurrentDateMinMax: "CurrentDateMinMax",
        CurrentPhase: "CurrentPhase",
        CurrentPeriod: "CurrentPeriod",
        FormWaitlisted: "FormWaitlisted",
        FormRegistered: "FormRegistered",
        ReservationAttemptSuccessful: "ReservationAttemptSuccessful",
        FormCancelled: "FormCancelled",
        FormSubmitted: "FormSubmitted",
        GroupMembership: "GroupMembership"
    }
    export type GroupMembershipUserType = "ResponseSubmitterIsMember" | "ResponseAssociatedUserIsMember" | "LastModifiedByIsMember" | "NetIdQuestion";
    export class ObservableFormResponseConditionDto implements IFormResponseConditionBase {
        And: KnockoutObservable<boolean>;
        Or: KnockoutObservable<boolean>;
        Not: KnockoutObservable<boolean>;
        QuestionId: KnockoutObservable<string>;
        PeriodAttributeId: KnockoutObservable<string>;
        ValueMatch: KnockoutObservable<string>;
        RegexValue: KnockoutObservable<string>;
        ParentCompositeResponseConditionId: KnockoutObservable<string>;
        PhaseId: KnockoutObservable<string>;
        MinimumDate: KnockoutObservable<string>;
        MaximumDate: KnockoutObservable<string>;
        SubmitDate: KnockoutObservable<boolean>;
        LastModifiedDate: KnockoutObservable<boolean>;
        CurrentDate: KnockoutObservable<boolean>;
        MinutesBeforeAssociatedDate: KnockoutObservable<number>;
        MinimumNumberValue: KnockoutObservable<number>;
        MaximumNumberValue: KnockoutObservable<number>;
        FormSubmitted: KnockoutObservable<boolean>;
        FormWaitlisted: KnockoutObservable<boolean>;
        FormRegistered: KnockoutObservable<boolean>;
        ReservationAttemptSuccessful: KnockoutObservable<boolean>;
        FormCancelled: KnockoutObservable<boolean>;
        PaymentStatus: KnockoutObservable<boolean>;
        PaymentMethod: KnockoutObservable<boolean>;
        PaymentPromised: KnockoutObservable<boolean>;
        ReferenceFormId: KnockoutObservable<string>;
        MembershipProviderId: KnockoutObservable<string>;
        ResponseSubmitterIsMember: KnockoutObservable<boolean>;
        ResponseAssociatedUserIsMember: KnockoutObservable<boolean>;
        LastModifiedByIsMember: KnockoutObservable<boolean>;
        SignatureSigned: KnockoutObservable<boolean>;
        SignatureSignedBy: KnockoutObservable<boolean>;
        SignatureDate: KnockoutObservable<boolean>;
        PeriodId: KnockoutObservable<string>;
        ResponseConditionValueType: KnockoutObservable<string>;
        ResponseConditionValueTypeText: KnockoutObservable<string>;
        ChildResponseConditions: KnockoutObservableArray<ObservableFormResponseConditionDto>;
        TextMergeField: KnockoutObservable<string>;
        HasValue: KnockoutObservable<boolean>;
        SavedForLater: KnockoutObservable<boolean>;
        MinimumReferenceFormMatchCount: KnockoutObservable<number>;
        MaximumReferenceFormMatchCount: KnockoutObservable<number>;
        MinimumReferenceFormMatchPercent: KnockoutObservable<number>;
        MaximumReferenceFormMatchPercent: KnockoutObservable<number>;
        ChildAggregate: KnockoutObservable<boolean>;

        private AvailableTriggerQuestions: KnockoutComputed<ITriggerQuestionDto[]>;
        private AvailableNetIdQuestions: KnockoutComputed<ITriggerQuestionDto[]>;
        private AvailableSignatureQuestions: KnockoutComputed<ITriggerQuestionDto[]>;
        private AvailablePhases: KnockoutComputed<IPhaseListing[]>;
        private AvailablePeriods: KnockoutComputed<IPeriodListing[]>;
        private AvailableMembershipProviders: KnockoutComputed<IMembershipProviderListing[]>;
        private AvailableMergeFields: KnockoutComputed<ITextMergeFieldListing[]>;

        private AvailableRealms: KnockoutComputed<IAvailableActiveDirectoryRealms>;
        private DefaultRealm: KnockoutComputed<string>;
        CourseCrnQuestionModel: KnockoutComputed<ICourseCrnQuestionModel>;
        AvailableTerms: KnockoutComputed<ITextValue[]>;
        ConditionLevel: KnockoutComputed<number>; //Nesting level for conditions once booleans are added.  Helps conveyed info. to assistive teach and create accessible names
        BooleanChildOrder: KnockoutComputed<number>; //For boolean child conditions, give them an order (1,2,3,etc) to convey info. to screen readers & build unique accessible names
        AccessibleNamePrefix: KnockoutComputed<string>; //Prefix to add to input labels to create an accessible name and convey info. to assistive tech
        AccessibleNameSuffix: KnockoutComputed<string>; //Sufffix to add to input labels to create an accessible name and convey info. to assistive tech
        AccessibleDescription: KnockoutComputed<string>; //Text that will be associated using aria-describedby

        ResponseEditorType: KnockoutObservable<FormResponseConditionEditorConfiguration.IFormResponseEditorType>;
        ResponseEditorTypeText: KnockoutComputed<string>;
        CanContainChildObjects: KnockoutObservable<boolean>;
        CanContainMultipleChildObjects: KnockoutObservable<boolean>;
        MinutesBeforeAssociatedDateRaw: KnockoutObservable<number>;
        MinutesBeforeModifier: KnockoutObservable<string>;
        GroupMembershipUserType: KnockoutObservable<GroupMembershipUserType>;
        SelectedPhase: KnockoutComputed<IPhaseListing>;
        SelectedPeriod: KnockoutComputed<IPeriodListing>;
        SelectedMembershipProvider: KnockoutComputed<IMembershipProviderListing>;
        DisplayText: KnockoutObservable<string>;
        DisplayHtml: KnockoutObservable<string>;
        TriggerQuestion: KnockoutComputed<ITriggerQuestionDto>;
        SelectedMergeField: KnockoutComputed<ITextMergeFieldListing>;
        private internalId: string;
        private dateTimeText: KnockoutComputed<string>;
        private componentVm: FormResponseConditionEditorViewModel;
        private isGroupingCondition: KnockoutComputed<boolean>;
        NetIdValueMatch: KnockoutObservable<string>;
        NetIdValueMatchRealm: KnockoutObservable<string>;
        private showRealmChooser: KnockoutComputed<boolean>;
        private specificRealm: KnockoutComputed<string>;
        private resolvedUser: KnockoutObservable<IResolvedUser>;
        CrnValueMatch: KnockoutObservable<string>;
        TermCodeValueMatch: KnockoutObservable<string>;
        resolvedCampusSection: KnockoutObservable<ICampusSection>;
        termOptions: ITextValue[];
        ChildAggregateReferenceFormId: KnockoutObservable<string>;
        AvailableChildForms: KnockoutComputed<{ Id: string, FormName: string }[]>;
        AvailableFormHierarchy: KnockoutComputed<IFormHierarchyInfo[]>;
        HasFormHierarchy: KnockoutComputed<boolean>;
        ChildFormId: KnockoutObservable<string>;
        ParentFormResponseCondition: ObservableFormResponseConditionDto;
        MaximumReferenceFormMatchPercentRaw: KnockoutObservable<string | number>;
        MinimumReferenceFormMatchPercentRaw: KnockoutObservable<string | number>;
        AvailableResponseEditorTypes: KnockoutComputed<ITextValuePair[]>
        public getInternalId(): string {
            return this.internalId;
        }

        private initializeResponseType(): FormResponseConditionEditorConfiguration.IFormResponseEditorType {
            var frcec = FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic;
            var formResponseCondition = this;

            for (let prop in frcec.ResponseEditorTypes) {
                if (frcec.ResponseEditorTypes.hasOwnProperty(prop)) {
                    if (frcec.ResponseEditorTypes[prop].MatchesResponseCondition(formResponseCondition)) {
                        return frcec.ResponseEditorTypes[prop];
                    }
                }
            }
            return frcec.ResponseEditorTypes.CurrentPhase;
        }

        private determineResponseConditionValueTypeText(): string {
            var valueType = null;
            var triggerQuestion, valueMatch;
            var responseCondition = this;

            valueType = responseCondition.ResponseConditionValueTypeText();
            if (valueType === FormResponseConditionValueType.ValueMatch) {

                triggerQuestion = responseCondition.TriggerQuestion();

                if (triggerQuestion) {
                    var questionTypeText = triggerQuestion.QuestionTypeText;

                    if (responseCondition.ResponseEditorType() === FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic.ResponseEditorTypes.QuestionCondition) {
                        if (questionTypeText === "QuestionChoice" || questionTypeText === "EventSession") {
                            valueMatch = responseCondition.ValueMatch();
                            $.each(triggerQuestion.QuestionChoices,
                                (index, itemValue) => {
                                    if (itemValue.ChoiceValue === valueMatch) {
                                        valueType = "ChoiceMatch";
                                    }
                                });
                        } else if (questionTypeText === "Signature") {
                            var signed = responseCondition.SignatureSigned();
                            if (signed !== null) {
                                valueType = "SignatureSigned";
                            } else if (responseCondition.SignatureDate()) {
                                valueType = "SignatureDate";
                            } else if (responseCondition.SignatureSignedBy()) {
                                valueType = "SignatureSignedBy";
                            }
                        }
                    } else {
                        if (questionTypeText === "EventSession") {
                            valueMatch = responseCondition.ValueMatch();
                            $.each(triggerQuestion.QuestionChoices, (index, itemValue) => {
                                if (itemValue.ChoiceValue === valueMatch) {
                                    valueType = "ChoiceMatch";
                                }
                            });
                        }
                    }  
                }
            }

            return valueType;
        }

        public constructor(formResponseCondition: FormResponseConditionDto, parentCondition: ObservableFormResponseConditionDto, componentVm: FormResponseConditionEditorViewModel) {
            this.componentVm = componentVm;
            this.ParentFormResponseCondition = parentCondition;
            let isNew = false;
            if (formResponseCondition === undefined || formResponseCondition === null) {
                formResponseCondition = new FormResponseConditionDto();
                formResponseCondition.ReferenceFormId = this.componentVm.DefaultReferenceFormId;
                isNew = true;
            }

            formResponseCondition.MaximumDate = Service.setDateValue(formResponseCondition.MaximumDate);
            formResponseCondition.MinimumDate = Service.setDateValue(formResponseCondition.MinimumDate);

            var mapping = { "ignore": ["ChildResponseConditions"] };
            komap.fromJS(formResponseCondition, mapping, this);

            this.ChildFormId = ko.pureComputed(() => {
                let f = this.ParentFormResponseCondition;
                while (f !== null && f.ResponseEditorType().Value !== "ChildFormCount" && f.ResponseEditorType().Value !== "ChildFormPercent") {
                    f = f.ParentFormResponseCondition;
                }

                if (f !== null) {
                    return f.ChildAggregateReferenceFormId();
                }

                return this.componentVm.DefaultReferenceFormId;
            });

            this.AvailableTriggerQuestions = ko.pureComputed(() => {
                var result = this.componentVm.AvailableTriggerQuestionsMap[this.ReferenceFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailableNetIdQuestions = ko.pureComputed(() => {
                var result = this.componentVm.AvailableNetIdQuestionsMap[this.ReferenceFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailableSignatureQuestions = ko.pureComputed(() => {
                var result = this.componentVm.AvailableSignatureQuestionsMap[this.ReferenceFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailablePhases = ko.pureComputed(() => {
                var result = this.componentVm.AvailablePhasesMap[this.ReferenceFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailablePeriods = ko.pureComputed(() => {
                var result = this.componentVm.AvailablePeriodsMap[this.ReferenceFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailableMergeFields = ko.pureComputed(() => {
                var result = this.componentVm.AvailableMergeFieldsMap[this.ReferenceFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailableChildForms = ko.pureComputed(() => {
                var result = this.componentVm.AvailableChildFormsMap[this.ChildFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.HasFormHierarchy = ko.pureComputed(() => {
                var result = this.componentVm.AvailableFormHierarchyMap[this.ChildFormId()];
                if (result === undefined || result === null) {
                    return false;
                }
                return result.length > 1;
            });

            this.AvailableFormHierarchy = ko.pureComputed(() => {
                var result = this.componentVm.AvailableFormHierarchyMap[this.ChildFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailableMembershipProviders = ko.pureComputed(() => {
                var result = this.componentVm.AvailableMembershipProvidersMap[this.ChildFormId()];
                if (result === undefined || result === null) {
                    return [];
                }
                return result;
            });

            this.AvailableResponseEditorTypes = ko.pureComputed(() => {
                let result = this.componentVm.responseEditorTypes;

                if (!this.componentVm.IsNonLegacyRegistrationFormMap[this.ChildFormId()]) {
                    result = result.filter(x => (x.Value !== "FormRegistered") && (x.Value !== "ReservationAttemptSuccessful")); // these types are only allowed with modern registration forms
                }

                if (!this.componentVm.AvailableChildFormsMap[this.ChildFormId()]?.length) {
                    result = result.filter(x => (x.Value !== "ChildFormCount") && (x.Value !== "ChildFormPercent"))
                }

                return result;
            });

            this.internalId = Service.createIdPrefix();

            this.ConditionLevel = ko.pureComputed(() => {
                if (!parentCondition) {
                    return 1;
                } else {
                    return parentCondition.ConditionLevel() + 1;
                }
            });

            this.BooleanChildOrder = ko.pureComputed(() => {
                let self = this;
                let retVal = -1;
                if (parentCondition && parentCondition.ChildResponseConditions()) {
                    parentCondition.ChildResponseConditions().forEach(function (item: ObservableFormResponseConditionDto, index: number) {
                        if (item.internalId == self.internalId) {
                            retVal = index + 1;
                            return;
                        }
                    });
                }
                return retVal;
            });

            this.AccessibleNamePrefix = ko.pureComputed(() => {
                return "Level " + this.ConditionLevel() + " ";
            });

            this.AccessibleNameSuffix = ko.pureComputed(() => {
                if (parentCondition && (parentCondition.And() || parentCondition.Or())) { //This is a child of parent boolean condition
                    if (parentCondition.And()) {
                        return ", condition " + this.BooleanChildOrder() + " for AND group";
                    }
                    if (parentCondition.Or()) {
                        return ", condition " + this.BooleanChildOrder() + " for OR group";
                    }
                } else {
                    return "";
                }
            });

            this.CourseCrnQuestionModel = ko.pureComputed(() => {
                var result = this.componentVm.AvailableCourseCrnQuestionModelsMap[this.ChildFormId()];
                if (result === undefined || result === null) {
                    return {} as ICourseCrnQuestionModel;
                }
                return result;
            });

            this.ResponseEditorType = ko.observable(this.initializeResponseType());

            var childConditions: ObservableFormResponseConditionDto[] = $.map(formResponseCondition.ChildResponseConditions, (element) => {
                var retVal = new ObservableFormResponseConditionDto(element, this, this.componentVm);
                if (retVal.ResponseEditorType() === null) {
                    return null;
                }
                return retVal;
            });

            this.ChildResponseConditions = ko.observableArray(childConditions);

            this.AccessibleDescription = ko.pureComputed(() => {
                if (this.And() || this.Or()) {
                    return "Has " + this.ChildResponseConditions().length + " child conditions";
                } else {
                    return "";
                }
            });

            var isGroupingCondition = (value: string) => {
                return (value === "And" || value === "Or" || value === "Not");
            }

            this.ResponseEditorTypeText = ko.pureComputed({
                read: () => {
                    var config = this.ResponseEditorType();
                    if (config !== undefined && config !== null) {
                        return config.Value;
                    }
                    return null;
                },
                write: (value) => {
                    var current = this.ResponseEditorType();
                    var currentValue = null;

                    if (current !== undefined && current !== null && current.Value !== undefined) {
                        currentValue = current.Value;
                    }

                    var config = FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic.ResponseEditorTypes[value];
                    if (config !== undefined && config !== null && config.Value !== undefined) {
                        if (currentValue !== config.Value) {
                            if (isGroupingCondition(currentValue)) {
                                if (config.Value !== "Or" && config.Value !== "And" && this.ChildResponseConditions().length) {
                                    if ((currentValue !== "Not" && this.ChildResponseConditions().length > 1) || this.ChildResponseConditions()[0].ChildResponseConditions().length) {
                                        this.componentVm.verifyModalVm.open(() => {
                                            this.ResponseEditorType(config);
                                        }, () => {
                                            this.ResponseEditorTypeText.notifySubscribers(currentValue);
                                        });

                                        return;
                                    }
                                }
                            }
                            this.ResponseEditorType(config);
                        }
                    }
                }
            });

            this.CanContainChildObjects = ko.pureComputed(() => {
                if (this.ResponseEditorType().CanContainChildObjects) {
                    return true;
                } else {
                    return false;
                }
            });

            this.CanContainMultipleChildObjects = ko.pureComputed(() => {
                if (this.ResponseEditorType().CanContainMultipleChildObjects) {
                    return true;
                } else {
                    return false;
                }
            });

            this.MinutesBeforeAssociatedDateRaw = ko.observable(null);
            this.MinutesBeforeModifier = ko.observable(null);
            var composedMinutes = this.MinutesBeforeAssociatedDate();
            var availableTimeIncrements = {
                Minutes: 1,
                Hours: 60,
                Days: 1440
            };
            this.MinutesBeforeAssociatedDate = ko.pureComputed({
                read: () => {
                    var rawValue = this.MinutesBeforeAssociatedDateRaw();
                    if (rawValue !== undefined && rawValue !== null) {
                        rawValue = parseInt(String(rawValue), 10);
                        var modifier = this.MinutesBeforeModifier();
                        if (modifier === "Hours") {
                            rawValue = rawValue * 60;
                        } else if (modifier === "Days") {
                            rawValue = rawValue * 1440;
                        }
                        return rawValue;
                    }
                    return null;
                },
                write: (value) => {
                    var intVal;
                    if (_.isFinite(value)) {
                        intVal = value;
                    } else {
                        intVal = parseInt(<any>value, 10);
                    }
                    var multiplierValue;
                    var divisibleSuccess = false;
                    if (intVal) {
                        for (var prop in availableTimeIncrements) {
                            if (availableTimeIncrements.hasOwnProperty(prop)) {
                                multiplierValue = availableTimeIncrements[prop];
                                if (multiplierValue) {
                                    if (intVal % multiplierValue === 0) {
                                        this.MinutesBeforeAssociatedDateRaw(intVal / multiplierValue);
                                        this.MinutesBeforeModifier(prop);
                                        divisibleSuccess = true;
                                    }
                                }
                            }
                        }
                        if (!divisibleSuccess) {
                            this.MinutesBeforeAssociatedDateRaw(intVal);
                            this.MinutesBeforeModifier("Minutes");
                        }
                    }
                }
            });

            this.MinutesBeforeAssociatedDate(composedMinutes);

            this.MaximumReferenceFormMatchPercentRaw = ko.observable(null);
            let maxPercent = this.MaximumReferenceFormMatchPercent();
            this.MaximumReferenceFormMatchPercent = ko.computed({
                read: () => {
                    var rawValue = this.MaximumReferenceFormMatchPercentRaw();
                    if (rawValue !== undefined && rawValue !== null) {
                        rawValue = parseInt(String(rawValue));
                        return rawValue / 100;
                    }
                    return null;
                },
                write: (value) => {
                    let val = parseFloat(<any>value);
                    
                    if (_.isFinite(value)) {
                        this.MaximumReferenceFormMatchPercentRaw((val * 100).toFixed());
                        return;
                    }
                    this.MaximumReferenceFormMatchPercentRaw(null);
                }
            });

            this.MaximumReferenceFormMatchPercent(maxPercent);

            this.MinimumReferenceFormMatchPercentRaw = ko.observable(null);
            let minPercent = this.MinimumReferenceFormMatchPercent();
            this.MinimumReferenceFormMatchPercent = ko.computed({
                read: () => {
                    var rawValue = this.MinimumReferenceFormMatchPercentRaw();
                    if (rawValue !== undefined && rawValue !== null) {
                        rawValue = parseInt(String(rawValue));
                        return rawValue / 100;
                    }
                    return null;
                },
                write: (value) => {
                    let val = parseFloat(<any>value);

                    if (_.isFinite(value)) {
                        this.MinimumReferenceFormMatchPercentRaw((val * 100).toFixed());
                        return;
                    }
                    this.MinimumReferenceFormMatchPercentRaw(null);
                }
            });

            this.MinimumReferenceFormMatchPercent(minPercent);

            this.GroupMembershipUserType = ko.observable(null);

            ko.computed(() => {
                var value = this.GroupMembershipUserType();

                if (value) {
                    if (value === "ResponseSubmitterIsMember") {
                        this.ResponseSubmitterIsMember(true);
                        this.ResponseAssociatedUserIsMember(true);
                        this.LastModifiedByIsMember(false);
                        this.TriggerQuestion(null);
                    } else if (value === "ResponseAssociatedUserIsMember") {
                        this.ResponseSubmitterIsMember(true);
                        this.ResponseAssociatedUserIsMember(true);
                        this.LastModifiedByIsMember(false);
                        this.TriggerQuestion(null);
                    } else if (value === "LastModifiedByIsMember") {
                        this.ResponseSubmitterIsMember(false);
                        this.ResponseAssociatedUserIsMember(false);
                        this.LastModifiedByIsMember(true);
                        this.TriggerQuestion(null);
                    } else if (value === "NetIdQuestion") {
                        this.ResponseSubmitterIsMember(false);
                        this.ResponseAssociatedUserIsMember(false);
                        this.LastModifiedByIsMember(false);
                    } else {
                        this.ResponseSubmitterIsMember(false);
                        this.ResponseAssociatedUserIsMember(false);
                        this.LastModifiedByIsMember(false);
                    }
                }
            });

            var questionId = this.QuestionId();
            var valueMatch = this.ValueMatch();
            var internalTriggerQuestion: KnockoutObservable<ITriggerQuestionDto> = ko.observable(null);

            this.TriggerQuestion = ko.computed({
                read: () => internalTriggerQuestion(),
                write: value => {
                    if (value) {
                        if (ko.utils.arrayIndexOf(this.ResponseEditorType().PropertiesUsed, "QuestionId") < 0) {
                            Logger.log("Rejecting value '" + value + "' for TriggerQuestion() as the current ResponseEditorType (" + this.ResponseEditorTypeText() + ") does not use the QuestionId field.");
                            return;
                        }

                        if (value.QuestionChoices) {
                            ko.utils.arrayForEach(value.QuestionChoices, function (item: IQuestionChoice, index: number) {
                                item.DisplayChoiceName = item.Archived ? item.ChoiceName + " (archived)" : item.ChoiceName;
                            });
                        }   
                    }

                    internalTriggerQuestion(value);
                }
            });

            ko.computed(() => {
                if (!this.ResponseConditionValueTypeText) {
                    throw "unable to initialize response condition editor";
                }
                var value = this.ResponseConditionValueTypeText();
                if (value && this.TriggerQuestion() && this.TriggerQuestion().QuestionTypeText === "Signature") {
                    if (value === "SignatureSigned") {
                        if (this.SignatureSigned() === null)
                            this.SignatureSigned(true);
                        this.SignatureSignedBy(false);
                        this.SignatureDate(false);
                    } else if (value === "SignatureSignedBy") {
                        this.SignatureSigned(null);
                        this.SignatureSignedBy(true);
                        this.SignatureDate(false);
                    } else if (value === "SignatureDate") {
                        this.SignatureSigned(null);
                        this.SignatureSignedBy(false);
                        this.SignatureDate(true);
                    }
                } else {
                    this.SignatureSigned(null);
                    this.SignatureSignedBy(null);
                    this.SignatureDate(null);
                }

                if (value === "ChildAggregateCountMax") {
                    this.MinimumReferenceFormMatchCount(null);
                }
                if (value === "ChildAggregateCountMin") {
                    this.MaximumReferenceFormMatchCount(null);
                }
                if (value === "ChildAggregatePercentMax") {
                    this.MinimumReferenceFormMatchPercent(null);
                }
                if (value === "ChildAggregatePercentMin") {
                    this.MaximumReferenceFormMatchPercent(null);
                } 
            });

            this.SelectedMergeField = ko.pureComputed(() => {
                var tmf = this.TextMergeField();
                if (tmf) {
                    return ko.utils.arrayFirst(this.AvailableMergeFields(), (item) => (item.Value === tmf));
                }
                return null;
            });

            this.SelectedPhase = ko.pureComputed(() => {
                var pid = this.PhaseId();
                if (pid) {
                    return ko.utils.arrayFirst(this.AvailablePhases(), (item) => (item.Id === pid));
                }
                return null;
            });

            this.SelectedPeriod = ko.pureComputed(() => {
                var pid = this.PeriodId();
                if (pid) {
                    return ko.utils.arrayFirst(this.AvailablePeriods(), (item) => (item.Id === pid));
                }
                return null;
            });

            this.SelectedMembershipProvider = ko.pureComputed(() => {
                var gid = this.MembershipProviderId();
                if (gid) {
                    return ko.utils.arrayFirst(this.AvailableMembershipProviders(), (item) => (item.Id === gid));
                }
                return null;
            });

            this.QuestionId = ko.pureComputed({
                read: () => {
                    var qi = this.TriggerQuestion();
                    if (qi) {
                        return qi.Id;
                    }
                    return null;
                },
                write: value => {
                    var length, i;
                    if (this.ResponseEditorType() === FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic.ResponseEditorTypes.GroupMembership) {
                        length = this.AvailableNetIdQuestions().length;
                        for (i = 0; i < length; i++) {
                            if (this.AvailableNetIdQuestions()[i].Id === value) {
                                this.TriggerQuestion(this.AvailableNetIdQuestions()[i]);
                                return;
                            }
                        }
                        //} else if (this.ResponseEditorType() === FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic.ResponseEditorTypes.SignatureProperty) {
                        //    length = this.AvailableSignatureQuestions().length;
                        //    for (i = 0; i < length; i++) {
                        //        if (this.AvailableSignatureQuestions()[i].Id === value) {
                        //            this.TriggerQuestion(this.AvailableSignatureQuestions()[i]);
                        //            return;
                        //        }
                        //    }
                    } else {
                        length = this.AvailableTriggerQuestions().length;
                        for (i = 0; i < length; i++) {
                            if (this.AvailableTriggerQuestions()[i].Id === value) {
                                this.TriggerQuestion(this.AvailableTriggerQuestions()[i]);
                                return;
                            }

                        }
                    }
                    this.TriggerQuestion(null);
                }
            });
            this.QuestionId(questionId);
            this.ValueMatch(valueMatch);
            this.ResponseConditionValueTypeText(this.determineResponseConditionValueTypeText());

            this.NetIdValueMatch = ko.observable(this.ValueMatch());
            this.NetIdValueMatchRealm = ko.observable(null);
            this.resolvedUser = ko.observable(null);

            ko.computed(() => {
                if (this.TriggerQuestion && this.TriggerQuestion() && (this.TriggerQuestion().QuestionTypeText === "NetId" || this.TriggerQuestion().QuestionTypeText === "Signature" && this.ResponseConditionValueTypeText() === "SignatureSignedBy")) {
                    if (this.resolvedUser())
                        this.ValueMatch(this.resolvedUser().LookupKey + "@" + this.resolvedUser().Realm);
                    else
                        this.ValueMatch(null);
                }
            });

            this.specificRealm = ko.pureComputed(() => {
                if (this.TriggerQuestion && this.TriggerQuestion() && this.TriggerQuestion().QuestionTypeText === "NetId") {
                    if (this.TriggerQuestion().SpecificValidationTypeText === "SpecificActiveDirectory") {
                        var boundRealm = this.TriggerQuestion().TypePatternMetadata;
                        if (boundRealm) {
                            return boundRealm;
                        }
                    }
                }

                if (this.componentVm && this.componentVm.AvailableRealms && this.componentVm.AvailableRealms.DefaultRealm)
                    return this.componentVm.AvailableRealms.DefaultRealm;

                return null;
            });
            this.showRealmChooser = ko.pureComputed(() => {
                if (this.TriggerQuestion && this.TriggerQuestion() && ((this.TriggerQuestion().QuestionTypeText === "NetId" && this.TriggerQuestion().SpecificValidationTypeText === "AnyActiveDirectory") || this.TriggerQuestion().QuestionTypeText === "Signature")) {
                    return true;
                }
                return false;
            });

            this.AvailableTerms = ko.pureComputed(() => {
                var result = this.componentVm.AllTerms;
                if (result === undefined || result === null) {
                    result = this.CourseCrnQuestionModel().AllTerms;
                    if (result === undefined || result === null) {
                        return [];
                    }
                }

                if (this.TriggerQuestion && this.TriggerQuestion() && this.TriggerQuestion().QuestionTypeText === "CourseCrn") {
                    let campus = this.CourseCrnQuestionModel().FormGroupCampus;

                    if (this.TriggerQuestion().SpecificValidationTypeText === "AnyTerm") {
                        campus = this.TriggerQuestion().TypePatternMetadata;
                    }

                    return _.chain(result).filter(x => x.Campus === campus).map(x => { return { Text: x.TermDescription, Value: x.TermCode } as ITextValue }).value();
                }

                return [];
            });

            this.CrnValueMatch = ko.observable(null);
            this.TermCodeValueMatch = ko.observable(null);
            this.resolvedCampusSection = ko.observable(null);

            ko.computed(() => {
                var editorType = this.ResponseEditorType();
                this.resetProperties(editorType.PropertiesUsed);
                editorType.SetBaseValues(this);
            });

            ko.computed(() => {
                let rcs = this.resolvedCampusSection();

                if (this.TriggerQuestion && this.TriggerQuestion() && this.TriggerQuestion().QuestionTypeText === "CourseCrn") {
                    if (rcs)
                        this.ValueMatch(`${rcs.Crn}|${rcs.TermCode}`);
                    else
                        this.ValueMatch(null);
                }
            });

            ko.computed(() => {
                var triggerQuestion, valueTypeText;
                var editorType = this.ResponseEditorType();

                if (editorType === FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic.ResponseEditorTypes.QuestionCondition) {
                    triggerQuestion = this.TriggerQuestion();
                    if (triggerQuestion) {
                        valueTypeText = this.ResponseConditionValueTypeText(); // call needed to register dependency on ResponseConditionValueTypeText
                        editorType.ResetValueTypes(this);
                    }
                }
            });

            ko.computed(() => {
                var tmf, valueTypeText;
                var editorType = this.ResponseEditorType();

                if (editorType === FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic.ResponseEditorTypes.TextMergeField) {
                    tmf = this.SelectedMergeField();
                    if (tmf) {
                        valueTypeText = this.ResponseConditionValueTypeText(); // call needed to register dependency on ResponseConditionValueTypeText
                        editorType.ResetValueTypes(this);
                    }
                }
            });

            this.DisplayText = ko.pureComputed(() => this.ResponseEditorType().GetDisplayText(this));
            this.DisplayHtml = ko.pureComputed(() => this.ResponseEditorType().GetDisplayHtml(this));

            this.isGroupingCondition = ko.pureComputed(() => {
                return isGroupingCondition(this.ResponseEditorType().Value);
            });
        }

        private surroundWith(source: ObservableFormResponseConditionDto, containerType: string, parentContainer: ObservableFormResponseConditionDto) {
            var newContainer = new ObservableFormResponseConditionDto(null, null, this.componentVm);
            newContainer.ResponseEditorTypeText(containerType);
            if (newContainer.ChildResponseConditions().length === 1) { // if we are surrounding with a "NOT" condition, we have to replace its single child rather than adding to an empty array
                newContainer.ChildResponseConditions()[0] = source;
            } else {                                       
                newContainer.ChildResponseConditions.push(source);
            }
            source.ParentFormResponseCondition = newContainer;

            if (parentContainer) {
                parentContainer.ChildResponseConditions.remove(source);
                parentContainer.ChildResponseConditions.push(newContainer);
                newContainer.ParentFormResponseCondition = parentContainer;
            } else {
                this.componentVm.FormResponseCondition(newContainer);
            }
            Logger.log("Before exiting method, newContainer(" + newContainer.internalId + ") has " + newContainer.ChildResponseConditions().length + " child conditions.");
        }

        private actuallyRemoveCondition(source: ObservableFormResponseConditionDto, parent: ObservableFormResponseConditionDto) {
            if (parent && parent.ChildResponseConditions)
                parent.ChildResponseConditions.remove(source);
        }

        private removeCondition(parentContainer: ObservableFormResponseConditionDto) {
            if (this.ResponseEditorType().Value === "And" || this.ResponseEditorType().Value === "Or") {
                if (this.ChildResponseConditions().length > 1) {
                    this.componentVm.verifyModalVm.open(() => {
                        this.actuallyRemoveCondition(this, parentContainer);
                    }, null);
                    return;
                }
            }

            this.actuallyRemoveCondition(this, parentContainer);
        }

        private resetProperties(ignoreColumns) {
            var vm = this;

            if (ignoreColumns) {
                ignoreColumns = ignoreColumns.slice(0);
            }
            var logif = (message) => {
                return;
                //if (propertyName === "PhaseId") {
                //    Logger.log(vm.internalId + ".PhaseId: " + message);
                //}
            };
            Logger.log("ResetProperties called on " + vm.internalId);
            var dto = new FormResponseConditionDto();
            var isFunction;
            Logger.log("ignoreColumns are: " + ignoreColumns);
            $.merge(ignoreColumns, this.componentVm.globalIgnoreColumns);
            
            for (var propertyName in dto) {
                if (dto.hasOwnProperty(propertyName)) {
                    logif("examining property " + propertyName);
                    if (ko.utils.arrayIndexOf(ignoreColumns, propertyName) === -1) {
                        logif("property is not in ignorelist");
                        if (vm[propertyName] !== undefined) {
                            logif("property exists in viewmodel");
                            isFunction = (typeof vm[propertyName] === "function");
                            logif("Property is a function: " + isFunction);
                            if (propertyName === "ChildResponseConditions") {
                                if (isFunction) {
                                    if (vm[propertyName]().length !== 0) {
                                        vm[propertyName]([]);
                                    }
                                }
                            } else {
                                if (isFunction) {
                                    logif("setting function property to null");
                                    vm[propertyName](null);
                                    logif("new value of property is: " + ko.utils.unwrapObservable(vm[propertyName]));
                                    logif("new value of property is: " + vm[propertyName]());

                                } else {
                                    logif("setting property to null");
                                    vm[propertyName] = null;
                                    logif("new value of property is: " + vm[propertyName]);
                                }
                            }
                        }
                    }
                }
                logif("new value of property is: " + ko.utils.unwrapObservable(vm[propertyName]));
            }  
        }

        public convertViewModel(): FormResponseConditionDto {
            var vm = this;
            var isFunction;
            var dto = new FormResponseConditionDto();

            for (var propertyName in dto) {
                if (dto.hasOwnProperty(propertyName)) {
                    if (vm[propertyName] !== undefined) {
                        isFunction = (typeof vm[propertyName] === "function");
                        if (propertyName === "ChildResponseConditions") {
                            if (isFunction) {
                                dto.ChildResponseConditions = $.map(vm.ChildResponseConditions(), element => element.convertViewModel());
                            }
                        } else {
                            if (isFunction) {
                                dto[propertyName] = vm[propertyName]();
                            } else {
                                dto[propertyName] = vm[propertyName];
                            }
                        }
                    }
                }
            }

            dto.MaximumDate = Service.setDateValue(dto.MaximumDate);
            dto.MinimumDate = Service.setDateValue(dto.MinimumDate);

            return dto;
        }

        public createObservableResponseCondition(formResponseCondition: FormResponseConditionDto): ObservableFormResponseConditionDto {
            return new ObservableFormResponseConditionDto(formResponseCondition, this, this.componentVm);
        }
    }

    export class VerifyModalVm {
        private modalElement: JQuery;
        private continueCallback: () => void;
        private cancelCallback: () => void;
        private clickedContinue: boolean;

        public constructor(element) {
            this.modalElement = $(element);
            this.continueCallback = null;
            this.cancelCallback = null;
            this.clickedContinue = false;

            this.modalElement.on("hidden.bs.modal", () => {
                if (this.clickedContinue) {
                    if (this.continueCallback !== null)
                        this.continueCallback();
                } else {
                    if (this.cancelCallback !== null)
                        this.cancelCallback();
                }

                this.clickedContinue = false;
                this.cancelCallback = null;
                this.continueCallback = null;
                Controls.endModalFocusTrap(this.modalElement[0]);
            });
        }

        public open(continueCallback?, cancelCallback?) {
            if (continueCallback)
                this.continueCallback = continueCallback;

            if (cancelCallback)
                this.cancelCallback = cancelCallback;

            this.modalElement.modal("show");
            Controls.startModalFocusTrap(this.modalElement[0]);
        }

        public clickContinue() {
            this.clickedContinue = true;
            this.modalElement.modal("hide");
        }
    }

    export interface IPhaseListing {
        Id: string;
        PhaseName: string;
    }
    export interface IPeriodListing {
        Id: string;
        PeriodName: string;
    }
    export interface IMembershipProviderListing {
        Id: string;
        GroupName: string;
    }
    export interface ITextValuePair {
        Text: string;
        Value: string;
    }
    export interface ITextMergeFieldListing extends ITextValuePair {
        ValueType: MergeFieldValueType | string;
        EmitsCollectionOfValues: boolean;
    }
    export type FormMap<T> = { [formId: string]: T[] };
    export interface IFormResponseConditionParameterPackage {
        AvailableTriggerQuestionsMap?: FormMap<ITriggerQuestionDto>;
        AvailableNetIdQuestionsMap: FormMap<ITriggerQuestionDto>;
        AvailableSignatureQuestionsMap: FormMap<ITriggerQuestionDto>;
        AvailablePhasesMap: FormMap<IPhaseListing>;
        AvailablePeriodsMap: FormMap<IPeriodListing>;
        AvailablePaymentStatus: ITextValuePair[];
        AvailablePaymentMethods: ITextValuePair[];
        AvailableFormHierarchyMap: FormMap<IFormHierarchyInfo>;
        DefaultReferenceFormId: string;
        AvailableMembershipProvidersMap: FormMap<IMembershipProviderListing>;
        AvailableRealms: IAvailableActiveDirectoryRealms;
        AvailableMergeFieldsMap: { [formId: string]: ITextMergeFieldViewModel };
        IsNonLegacyRegistrationFormMap: { [formId: string]: boolean };
        AvailableCourseCrnQuestionModelsMap: { [formId: string]: ICourseCrnQuestionModel };
        AvailableChildFormsMap: FormMap<{ Id: string, FormName: string }>;
        // This list contains terms used for course CRN answer values. It's loaded once here
        // to avoid repetitive loads in each CourseCrnQuestionModel within the form hierarchy,
        // as all forms and their child forms share the same terms.
        AllTerms?: ICampusTermListing[];
    }

    export interface IExternalVm {
        formResponseConditionEditor?: FormResponseConditionEditorViewModel;
    }

    export interface IFormResponseConditionEditorParams {
        formResponseCondition: IFormResponseConditionDto;
        formResponseConditionParameterPackage: IFormResponseConditionParameterPackage;
        responseEditorTypesNotAllowed?: string[];
        externalVm?: IExternalVm;
        afterRender?: (vm: FormResponseConditionEditorViewModel, elements: HTMLElement[]) => void;
    }

    export class FormResponseConditionEditorViewModel {
        public globalIgnoreColumns = ["ResponseConditionValueTypeText", "ResponseConditionValueType", "ParentCompositeResponseConditionId", "ReferenceFormId"];
        public initialView: string = "FullFormResponseConditionEditor";
        public AvailableFormHierarchyMap: FormMap<IFormHierarchyInfo>;
        public FormResponseCondition: KnockoutObservable<ObservableFormResponseConditionDto>;
        public AvailableTriggerQuestionsMap: FormMap<ITriggerQuestionDto>;
        public AvailableNetIdQuestionsMap: FormMap<ITriggerQuestionDto>;
        public AvailableSignatureQuestionsMap: FormMap<ITriggerQuestionDto>;
        public AvailablePhasesMap: FormMap<IPhaseListing>;
        public AvailablePeriodsMap: FormMap<IPeriodListing>;
        public AvailablePaymentStatus: ITextValuePair[];
        public AvailablePaymentMethods: ITextValuePair[];
        public AvailableMembershipProvidersMap: FormMap<IMembershipProviderListing>;
        public DefaultReferenceFormId: string;
        public AvailableRealms: IAvailableActiveDirectoryRealms;
        public ShowAdvancedOptions: KnockoutObservable<boolean>;
        public AvailableMergeFieldsMap: FormMap<ITextMergeFieldListing>;
        public verifyModalVm: VerifyModalVm;
        public responseEditorTypes: ITextValuePair[];
        public afterRender: (vm: FormResponseConditionEditorViewModel, elements: HTMLElement[]) => void;
        validateRegexUrl: string;
        AvailableCourseCrnQuestionModelsMap: { [formId: string]: ICourseCrnQuestionModel };
        AvailableChildFormsMap: FormMap<{ Id: string, FormName: string }>;
        IsNonLegacyRegistrationFormMap: { [formId: string]: boolean };
        public AllTerms: ICampusTermListing[];

        private getQuestionTypeString(question: ITriggerQuestionDto): string {
            if (question !== null && question !== undefined) {
                let identifier = <string>question.QuestionTypeText;
                
                if (identifier === "DateTime" || identifier === "Number") {
                    let svtt = question.SpecificValidationTypeText;
                    if (!svtt)
                        svtt = identifier === "DateTime" ? "Date" : "Decimal";
                    identifier = identifier + "_" + svtt;
                }
                else if (identifier.equalsIgnoreCase("DropDownList") || identifier.equalsIgnoreCase("RadioButtonList") || identifier.equalsIgnoreCase("CheckBoxList") || identifier.equalsIgnoreCase("SelectList")) {
                    identifier = "QuestionChoice";
                }

                return identifier;
            }
            else {
                return "";
            }
        }

        private initializeTriggerQuestions(questionsMap: FormMap<ITriggerQuestionDto>) {
            var i, length, questions: ITriggerQuestionDto[];
            for (var formId in questionsMap) {
                if (questionsMap.hasOwnProperty(formId)) {
                    questions = questionsMap[formId];
                    length = questions.length;
                    for (i = 0; i < length; i++) {
                        questions[i].QuestionTypeText = <FormBuilder.QuestionType>this.getQuestionTypeString(questions[i]);
                    }
                }
            }
        }

        private initializeFormHierarchy(availableFormHierarchy: FormMap<IFormHierarchyInfo>) {
            const keys = _.keys(availableFormHierarchy);

            for (let key of keys) {
                var i, length;
                var afh = [];
                let val = availableFormHierarchy[key];

                if (val) {
                    length = val.length;
                    val.sort((a, b) => (b.Level - a.Level));
                    for (i = 0; i < length; i += 1) {
                        afh.push({ formId: val[i].FormId, name: Array(val[i].Level + 1).join("-") + val[i].FormName });
                    }
                }
                availableFormHierarchy[key] = afh;
                (availableFormHierarchy[key] as any).HasFormHierarchy = afh.length > 1;
            }
        }

        private initializeMergeFieldsMapping(mapping: { [formId: string]: ITextMergeFieldViewModel }) {
            this.AvailableMergeFieldsMap = {};
            if (mapping) {
                _.each(mapping, (val, key) => {
                    this.AvailableMergeFieldsMap[key] = this.initializeTextMergeFields(val);
                });
            }
        }

        private initializeTextMergeFields(tmfvm: ITextMergeFieldViewModel): ITextMergeFieldListing[] {
            var atmf = [];

            function walkCategories(categories: ITextMergeFieldCategory[], displayName: string[]) {
                if (categories) {
                    _.each(categories, cat => {
                        if (cat) {
                            displayName.push(cat.CategoryName);
                            if (cat.MergeFields) {
                                _.each(cat.MergeFields, mf => {
                                    if (mf) {
                                        displayName.push(mf.DisplayText);
                                        atmf.push({ Text: displayName.join(" : "), Value: mf.PlaceholderText, ValueType: mf.MergeFieldValueType, EmitsCollectionOfValues: mf.EmitsCollectionOfValues });
                                        displayName.pop();
                                    }
                                });
                            }
                            walkCategories(cat.Categories, displayName);
                            displayName.pop();
                        }
                    });
                }
            }

            if (tmfvm) {
                walkCategories(tmfvm.Categories, []);
            }

            return atmf;
        }

        public serializeToForm(fieldNamePrefix, targetContainer) {
            Service.serializeToForm(fieldNamePrefix, targetContainer, this.FormResponseCondition().convertViewModel());
        }

        public serializeToFormResponseCondition() {
            return this.FormResponseCondition().convertViewModel();
        }

        private chooseResponseConditionTemplate(formResponseCondition: ObservableFormResponseConditionDto): string {
            var responseType = formResponseCondition.ResponseEditorType();
            var responseTypeValue = "CurrentPhase";
            if (responseType) {
                responseTypeValue = responseType.Value;
            }
            return "formResponseConditionAdvancedTemplate" + responseTypeValue;
        }

        private chooseQuestionConditionTemplate(formResponseCondition: ObservableFormResponseConditionDto): string {
            if (formResponseCondition.TriggerQuestion()) {
                return "formResponseConditionAdvancedTemplateQuestionCondition_" + formResponseCondition.TriggerQuestion().QuestionTypeText;
            }
            return null;
        }

        private chooseTextMergeFieldTemplate(formResponseCondition: ObservableFormResponseConditionDto): string {
            if (formResponseCondition.SelectedMergeField()) {
                return "formResponseConditionAdvancedTemplateTextMergeField_" + formResponseCondition.SelectedMergeField().ValueType;
            }
            return null;
        }

        public rebindConditionEditor(source: FormResponseConditionDto) {
            var condition = new ObservableFormResponseConditionDto(source, null, this);
            this.FormResponseCondition(condition);
        }

        public rebindConditionParameters(formResponseConditionParameterPackage: IFormResponseConditionParameterPackage) {
            this.AvailableTriggerQuestionsMap = formResponseConditionParameterPackage.AvailableTriggerQuestionsMap || {};
            this.AvailableNetIdQuestionsMap = formResponseConditionParameterPackage.AvailableNetIdQuestionsMap || {};
            this.AvailableSignatureQuestionsMap = formResponseConditionParameterPackage.AvailableSignatureQuestionsMap || {};
            this.AvailablePhasesMap = formResponseConditionParameterPackage.AvailablePhasesMap || {};
            this.AvailablePeriodsMap = formResponseConditionParameterPackage.AvailablePeriodsMap || {};
            this.AvailablePaymentStatus = formResponseConditionParameterPackage.AvailablePaymentStatus || [];
            this.AvailablePaymentMethods = formResponseConditionParameterPackage.AvailablePaymentMethods || [];
            this.AvailableMembershipProvidersMap = formResponseConditionParameterPackage.AvailableMembershipProvidersMap || {};
            this.DefaultReferenceFormId = formResponseConditionParameterPackage.DefaultReferenceFormId || null;
            this.AvailableRealms = formResponseConditionParameterPackage.AvailableRealms || { Realms: [], DefaultRealm: null };
            this.AvailableFormHierarchyMap = JSON.parse(JSON.stringify(formResponseConditionParameterPackage.AvailableFormHierarchyMap || {}));
            this.AvailableCourseCrnQuestionModelsMap = formResponseConditionParameterPackage.AvailableCourseCrnQuestionModelsMap || {};
            this.AvailableChildFormsMap = formResponseConditionParameterPackage.AvailableChildFormsMap || {};
            this.AllTerms = formResponseConditionParameterPackage.AllTerms;

            this.initializeFormHierarchy(this.AvailableFormHierarchyMap);
            this.initializeTriggerQuestions(this.AvailableTriggerQuestionsMap);
            this.initializeMergeFieldsMapping(formResponseConditionParameterPackage.AvailableMergeFieldsMap || {});
        }

        private afterConditionEditorRender(elements: HTMLElement[]) {
            if (this.afterRender)
                this.afterRender(this, elements);
        }

        public constructor(params: IFormResponseConditionEditorParams) {
            if (!params)
                throw "missing form response condition editor params";

            this.AvailableTriggerQuestionsMap = params.formResponseConditionParameterPackage.AvailableTriggerQuestionsMap || {};
            this.AvailableNetIdQuestionsMap = params.formResponseConditionParameterPackage.AvailableNetIdQuestionsMap || {};
            this.AvailableSignatureQuestionsMap = params.formResponseConditionParameterPackage.AvailableSignatureQuestionsMap || {};
            this.AvailablePhasesMap = params.formResponseConditionParameterPackage.AvailablePhasesMap || {};
            this.AvailablePeriodsMap = params.formResponseConditionParameterPackage.AvailablePeriodsMap || {};
            this.AvailablePaymentStatus = params.formResponseConditionParameterPackage.AvailablePaymentStatus || [];
            this.AvailablePaymentMethods = params.formResponseConditionParameterPackage.AvailablePaymentMethods || [];
            this.AvailableMembershipProvidersMap = params.formResponseConditionParameterPackage.AvailableMembershipProvidersMap || {};
            this.DefaultReferenceFormId = params.formResponseConditionParameterPackage.DefaultReferenceFormId || null;
            this.AvailableRealms = params.formResponseConditionParameterPackage.AvailableRealms || { Realms: [], DefaultRealm: null };
            this.AvailableFormHierarchyMap = JSON.parse(JSON.stringify(params.formResponseConditionParameterPackage.AvailableFormHierarchyMap || {}));
            this.AvailableCourseCrnQuestionModelsMap = params.formResponseConditionParameterPackage.AvailableCourseCrnQuestionModelsMap || {};
            this.AvailableChildFormsMap = params.formResponseConditionParameterPackage.AvailableChildFormsMap || {};
            this.AllTerms = params.formResponseConditionParameterPackage.AllTerms;
            this.ShowAdvancedOptions = ko.observable(true);

            this.initializeFormHierarchy(this.AvailableFormHierarchyMap);
            this.initializeTriggerQuestions(this.AvailableTriggerQuestionsMap);
            this.initializeMergeFieldsMapping(params.formResponseConditionParameterPackage.AvailableMergeFieldsMap || {});

            this.FormResponseCondition = ko.observable(new ObservableFormResponseConditionDto(params.formResponseCondition, null, this));

            if (params.externalVm)
                params.externalVm.formResponseConditionEditor = this;

            var typesNotAllowed = params.responseEditorTypesNotAllowed || [];

            this.IsNonLegacyRegistrationFormMap = params.formResponseConditionParameterPackage.IsNonLegacyRegistrationFormMap || {};

            this.responseEditorTypes = [];

            $.each(FormResponseConditionEditorConfiguration.FormResponseConditionEditorConfigurationStatic.ResponseEditorTypes, (key, value) => {
                if ($.inArray(key, typesNotAllowed) === -1)
                    this.responseEditorTypes.push(<ITextValuePair>{ Text: value.FriendlyName, Value: key });
            });

            this.verifyModalVm = new VerifyModalVm($("#formResponseConditionEditorVerifyModal"));

            if (params.afterRender && typeof (params.afterRender) === "function")
                this.afterRender = params.afterRender;
            else
                this.afterRender = null;

            var globals = Service.globalPageData();
            this.validateRegexUrl = globals.urls.validateRegex;
        }
    }

    export class QuestionTriggerFormResponseConditionEditorViewModel extends FormResponseConditionEditorViewModel {

        constructor(params: IFormResponseConditionEditorParams) {
            super(params);
            this.initialView = "QuestionTriggerConditionEditor";
            // set up defaults
            this.FormResponseCondition().ResponseEditorTypeText("QuestionCondition");
        }
    }
}
